<template>
  <Modal v-model:show="showModal">
    <h3 class="text-base font-semibold text-ui-active mb-4">
      Welcome to HaspDesigner
    </h3>

    <!-- News -->
    <div v-if="config.news.length" class="mb-4 rounded-md bg-white/10 border border-white/20 p-3">
      <p class="text-xs font-semibold text-ui-active uppercase tracking-wide mb-2">What's new</p>
      <ul class="list-disc list-inside space-y-1 text-xs text-gray-300">
        <li v-for="(item, i) in config.news" :key="i" v-html="item" />
      </ul>
    </div>

    <!-- Downloads -->
    <div v-if="config.downloads.length" class="mb-4 flex flex-wrap gap-2">
      <a
        v-for="dl in config.downloads"
        :key="dl.platform"
        :href="isTauri ? dl.externalUrl : dl.url"
        rel="noopener"
        class="inline-flex items-center gap-1.5 rounded-md bg-white/10 hover:bg-white/20 border border-white/20 hover:border-ui-active text-white text-xs px-3 py-1.5 no-underline transition-colors"
        @click.prevent="openDownload(dl)"
      >
        <span>{{ dl.icon }}</span>
        <span>{{ dl.label }}</span>
      </a>
    </div>

    <div class="mt-4 flex items-center justify-between">
      <label class="flex items-center gap-2 text-xs text-gray-400 cursor-pointer select-none">
        <input type="checkbox" v-model="dontShow" class="accent-cyan-500 cursor-pointer" />
        Do not show again
      </label>
      <form-button @click.prevent="closeModal">Close</form-button>
    </div>
  </Modal>
</template>

<script>
import { ref, onMounted } from 'vue';
import Modal from './Modal.vue';
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';
import { welcomeConfig } from '../config/welcome.js';

const isTauri = !!window.__TAURI__;

export default {
  name: 'WelcomeModal',
  components: { Modal, Carousel, Slide, Pagination, Navigation },
  setup() {
    const cookieName = ref('');
    const showModal = ref(false);
    const dontShow = ref(false);
    const config = ref(welcomeConfig);

    const getCookie = (name) => {
      const parts = `; ${document.cookie}`.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    };

    const setCookie = (name, value, days) => {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
    };

    const getAppVersion = async () => {
      if (isTauri) {
        const { getVersion } = await import('@tauri-apps/api/app');
        return await getVersion();
      }
      return __APP_VERSION__;
    };

    const openDownload = async (dl) => {
      const url = isTauri ? dl.externalUrl : dl.url;
      if (isTauri) {
        const { openUrl } = await import('@tauri-apps/plugin-opener');
        await openUrl(url);
      } else {
        window.open(url, '_blank', 'noopener');
      }
    };

    const closeModal = () => {
      if (dontShow.value) setCookie(cookieName.value, 'true', 365);
      showModal.value = false;
    };

    onMounted(async () => {
      const version = await getAppVersion();
      cookieName.value = `haspdesigner-welcome-${version}`;
      if (!getCookie(cookieName.value)) showModal.value = true;
    });

    return { showModal, dontShow, closeModal, config, isTauri, openDownload };
  },
};
</script>

